import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["checkbox", "formGroup"]
  static values = {inverted: Boolean}

  connect() {
    if (this.hasCheckboxTarget) {
      this.toggle();
    }
  }

  toggle() {
    if (this.hasFormGroupTarget) {
      const shouldShow = this.invertedValue ? !this.checkboxTarget.checked : this.checkboxTarget.checked;
      if (shouldShow) {
        this.formGroupTarget.classList.remove("d-none");
      } else {
        this.formGroupTarget.classList.add("d-none");
      }
    }
  }
}
